import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Heart } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#2C362F] text-white/80 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 bg-primary rounded-xl flex items-center justify-center">
                <Package className="w-4 h-4 text-white" strokeWidth={1.5} />
              </div>
              <span className="font-semibold text-lg text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>BorrowTools</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              Your community marketplace for buying, selling, lending, and sharing locally.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>Browse</h4>
            <div className="flex flex-col gap-2">
              <Link to="/browse?category=sale" className="text-sm text-white/60 hover:text-white transition-colors">Items for Sale</Link>
              <Link to="/browse?category=free" className="text-sm text-white/60 hover:text-white transition-colors">Free Items</Link>
              <Link to="/browse?category=lending" className="text-sm text-white/60 hover:text-white transition-colors">Lending</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>Account</h4>
            <div className="flex flex-col gap-2">
              <Link to="/register" className="text-sm text-white/60 hover:text-white transition-colors">Sign Up</Link>
              <Link to="/login" className="text-sm text-white/60 hover:text-white transition-colors">Sign In</Link>
              <Link to="/create-listing" className="text-sm text-white/60 hover:text-white transition-colors">Post a Listing</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>Support</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-white/60">help@borrowtools.com</span>
              <span className="text-sm text-white/60">Community Guidelines</span>
              <span className="text-sm text-white/60">Safety Tips</span>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-white/40">2025 BorrowTools. All rights reserved.</p>
          <p className="text-xs text-white/40 flex items-center gap-1">Made with <Heart className="w-3 h-3 text-primary" fill="currentColor" /> for local communities</p>
        </div>
      </div>
    </footer>
  );
}
